
const Sounds = {
    whoosh:0    ,
    buzz:1,
    merryChristmas:2,
    grabTheToy:3,
    lookAtTheList:4,
    wrapTheGift:5,
    addTheBow:6,
    dropTheGift:7,
    wellDone:8,
    moreGifts:9,
}

class SoundfxPlayer{
    constructor() {
        this.initialized = false;          
        this.currentSfxIndex =0;
        this.audiopool = [];
        this.pannerNodes = [];
    }

    initAudio() {
        if (this.audioContext) return;
        this.initialized = true;
        this.sounds= [
            new Audio('sfx/whoosh.wav'),           
            new Audio('sfx/buzz.wav'),           
            new Audio('sfx/MerryChristmas2.mp3'),
            new Audio('sfx/GrabTheToy.mp3'),
            new Audio('sfx/LookAtTheList.mp3'),
            new Audio('sfx/WrapTheGift.mp3'),
            new Audio('sfx/AddTheBow.mp3'),
            new Audio('sfx/DropTheGift.mp3'),
            new Audio('sfx/WellDone.mp3'),
            new Audio('sfx/MoreGifts.mp3'),
        ];

        this.audioContext = new AudioContext();
        this.audioContext.listener.upY.value = 1;        
        let gain = this.audioContext.createGain();
        gain.connect(this.audioContext.destination);
        
        for (let i = 0; i < 25; i++) {
            const audio = new Audio();            
            this.audiopool.push(audio);
            const element = this.audioContext.createMediaElementSource(audio);
            
            const pn = new PannerNode(this.audioContext, {
                panningModel: 'HRTF',
                distanceModel: 'exponential',
            });

            element.connect(pn);
            pn.connect(gain);
            this.pannerNodes.push(pn);
        }
    }

    playSound(audioIndex, pos) {
        if(!this.audioContext) return;
        if(!pos || !pos[0] || isNaN(pos[0])){
            pos=[0,0,0];
        }
        
        this.pannerNodes[this.currentSfxIndex].positionX.value = pos[0];
        this.pannerNodes[this.currentSfxIndex].positionY.value = pos[1];
        this.pannerNodes[this.currentSfxIndex].positionZ.value = pos[2];

        this.audiopool[this.currentSfxIndex].src = this.sounds[audioIndex].src;        
        this.audiopool[this.currentSfxIndex].play();
        this.currentSfxIndex = (this.currentSfxIndex + 1) % 25;
    }
};
